import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import {
  InviteC,
  withRouteMatchParams,
  IRouteMatchParamsHOCProps
} from '@unikey/unikey-commons/release/comm';

import {
  attemptRetrieveAdminInviteByToken,
  PartnerCustomizations, IPartnerCustomizations,
  ENavPages, navConfig,
  IPendingRedirectActionParams,
  addPendingRedirect,
} from '../internal';

interface IProps extends WrappedComponentProps, IPartnerCustomizations, IRouteMatchParamsHOCProps {
  getInvitationDetails(token: string): Promise<InviteC>,
  addPendingRedirect(redirOpts: IPendingRedirectActionParams): void,
}

class AdminInvitationTokenParserContainer extends Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  componentDidMount() {
    const encodedInviteToken = encodeURIComponent(this.props.match.params.inviteToken ?? '')
    return this.props.getInvitationDetails(this.props.match.params.inviteToken ?? '')
      .then((inviteDetails: InviteC) => {
        // newer invites are marked with `usernameRestricted: false` and can be redeemed by any account.
        if (inviteDetails.usernameRestricted) {
          this.props.addPendingRedirect({ pathname: navConfig.get(ENavPages.adminInviteRegister)!.linkTo([encodedInviteToken]) });
        } else {
          this.props.addPendingRedirect({ pathname: navConfig.get(ENavPages.adminInviteAccept)!.linkTo([encodedInviteToken]) });
        }
      })
  }

  render() {
    if (this.props.render) {
      return this.props.render();
    }
    return (
      <section className='access-container' />
    )
  }
}

function mapStateToProps(state: any) {
  return {

  };
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  getInvitationDetails: attemptRetrieveAdminInviteByToken,
  addPendingRedirect
}, dispatch);


export default PartnerCustomizations(
  withRouteMatchParams(
    connect(mapStateToProps, mapDispatchToProps)(
      injectIntl(AdminInvitationTokenParserContainer, { forwardRef: true })
    )
  ), { componentName: 'AdminInvitationTokenParser', unauthenticated: true })